module.exports = __webpack_public_path__ + "static/media/howtobefat_img_6.0de84c66.png";